import { createReducer } from '@reduxjs/toolkit';
import { State, RequestError } from 'types';
import { clearStateSlice } from '../clear-slice/actions';
import { createProductCode, createdProductCode, deleteProductCode, deletedProductCode } from './actions';

export const INITIAL_STATE: State = {
  status: undefined,
  error: undefined,
  errorType: undefined,
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<State>(INITIAL_STATE, (builder) =>
  builder
    .addCase(createProductCode, (state) => {
      state.status = 'loading';
    })
    .addCase(createdProductCode, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
      } else {
        state.error = undefined;
        state.status = 'success';
      }
    })
    .addCase(deleteProductCode, (state) => {
      state.status = 'loading';
    })
    .addCase(deletedProductCode, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
        state.errorType = 'delete';
      } else {
        state.error = undefined;
        state.status = 'success';
      }
    })

    .addCase(clearStateSlice, (state, action) => {
      const { payload } = action;
      if (payload?.sliceReducer === 'ProductCode') {
        if (payload?.sliceKey) {
          return {
            ...state,
            [payload.sliceKey]: INITIAL_STATE[payload.sliceKey],
          };
        } else {
          return INITIAL_STATE;
        }
      }
      return state;
    })
);
